import { IModalNursery } from './types';

import useModalNursery from '../../../Home/components/ModalNursery/hooks/useModalNursery';
import Icon from 'v2/components/Icon';
import Box from 'v2/components/UI/Box';
import ButtonBase from 'v2/components/UI/ButtonBase';
import Text from 'v2/components/UI/Text';
import { ReactComponent as FishIcon } from '../../../../assets/icons/peixe-icon.svg';
import { ReactComponent as ShrimpIcon } from '../../../../assets/icons/camarão-icon.svg';
import moment from 'moment';

const ModalNursery: React.FC<IModalNursery> = ({ isOpen, data, onClose }) => {
  const { nursery } = useModalNursery({ data });

  const renderIcon = () => {
    const color = '#1b1b1b';
    if (nursery?.specie_category === 'Camarão') {
      return <ShrimpIcon width={26} height={26} color={color} fill={color} />;
    }

    return <FishIcon width={26} height={26} color={color} fill={color} />;
  };

  return (
    <Box
      display={isOpen ? 'flex' : 'none'}
      position="absolute"
      top={0}
      bottom={0}
      left={0}
      width="100%"
      height="100vh"
      alignItems="center"
      justifyContent="center"
      zIndex={10000}
      flex={1}
    >
      <Box
        position="fixed"
        width="100%"
        height="100vh"
        background="rgba(0, 0, 0, 0.7)"
        alignItems="center"
        justifyContent="center"
        flex={1}
      >
        <Box
          background="#fff"
          borderRadius={12}
          width="40%"
          gap={30}
          position="fixed"
          justifyContent="space-between"
          max-width={1000}
          flexDirection="column"
          padding={30}
        >
          <Box
            alignItems="center"
            justifyContent="space-between"
            width={'100%'}
          >
            <Box alignItems="center" gap={20}>
              <Box padding={15} background={'#1b1b1b30'} borderRadius={100}>
                {renderIcon()}
              </Box>

              <Box flexDirection="column" gap={2}>
                <Text fontSize={24} fontWeight={500}>
                  {nursery?.description}
                </Text>

                <Box gap={5}>
                  <Text fontSize={16}>{nursery?.type}</Text>|
                  <Text fontSize={16}>{nursery?.system}</Text>
                </Box>
              </Box>
            </Box>

            <ButtonBase onClick={onClose}>
              <Icon iconName="CloseOutlined" htmlColor="#226A43" />
            </ButtonBase>
          </Box>

          <Box flexWrap="wrap" gap={20}>
            <Box alignItems="center" gap={10} width="calc(50% - 10px)">
              <Icon
                iconName="ChecklistOutlined"
                htmlColor="#2e7d32"
                size={40}
              />
              <Box flexDirection="column" gap={2}>
                <Text fontSize={14}>Status do cultivo:</Text>
                <Text fontSize={16} fontWeight={500}>
                  {nursery?.status}
                </Text>
              </Box>
            </Box>

            <Box alignItems="center" gap={10} width="calc(50% - 10px)">
              <Icon
                iconName="CalendarMonthOutlined"
                htmlColor="#2e7d32"
                size={40}
              />
              <Box flexDirection="column" gap={2}>
                <Text fontSize={14}>Ciclo criado em</Text>
                <Text fontSize={16} fontWeight={500}>
                  {moment(nursery?.begin).format('DD/MM/YYYY')}
                </Text>
              </Box>
            </Box>

            <Box alignItems="center" gap={10} width="calc(50% - 10px)">
              <Icon iconName="MapOutlined" htmlColor="#2e7d32" size={40} />
              <Box flexDirection="column" gap={2}>
                <Text fontSize={14}>Área (m²):</Text>
                <Text fontSize={16} fontWeight={500}>
                  {nursery?.area}
                </Text>
              </Box>
            </Box>

            <Box alignItems="center" gap={10} width="calc(50% - 10px)">
              <Icon iconName="GroupsOutlined" htmlColor="#2e7d32" size={40} />
              <Box flexDirection="column" gap={2}>
                <Text fontSize={14}>Densidade (animais/m²):</Text>
                <Text fontSize={16} fontWeight={500}>
                  {nursery?.density}
                </Text>
              </Box>
            </Box>

            <Box alignItems="center" gap={10} width="calc(50% - 10px)">
              <Icon
                iconName="CalendarTodayOutlined"
                htmlColor="#2e7d32"
                size={40}
              />
              <Box flexDirection="column" gap={2}>
                <Text fontSize={14}>Dias de cultivo:</Text>
                <Text fontSize={16} fontWeight={500}>
                  {nursery?.growingDays}
                </Text>
              </Box>
            </Box>

            <Box alignItems="center" gap={10} width="calc(50% - 10px)">
              <Icon iconName="SpeedOutlined" htmlColor="#2e7d32" size={40} />
              <Box flexDirection="column" gap={2}>
                <Text fontSize={14}>Fator de Conversão Animal:</Text>
                <Text fontSize={16} fontWeight={500}>
                  {nursery?.fca}
                </Text>
              </Box>
            </Box>

            <Box alignItems="center" gap={10} width="calc(50% - 10px)">
              <Icon iconName="ScaleOutlined" htmlColor="#2e7d32" size={40} />
              <Box flexDirection="column" gap={2}>
                <Text fontSize={14}>Total de ração usada:</Text>
                <Text fontSize={16} fontWeight={500}>
                  {nursery?.totalFoodOffered} kg
                </Text>
              </Box>
            </Box>

            <Box alignItems="center" gap={10} width="calc(50% - 10px)">
              <Icon
                iconName="OtherHousesOutlined"
                htmlColor="#2e7d32"
                size={40}
              />
              <Box flexDirection="column" gap={2}>
                <Text fontSize={14}>Protocolo:</Text>
                <Text fontSize={16} fontWeight={500}>
                  {nursery?.protocol}
                </Text>
              </Box>
            </Box>

            <Box alignItems="center" gap={10} width="calc(50% - 10px)">
              <Icon
                iconName="OutlinedFlagOutlined"
                htmlColor="#2e7d32"
                size={40}
              />
              <Box flexDirection="column" gap={2}>
                <Text fontSize={14}>População inicial:</Text>
                <Text fontSize={16} fontWeight={500}>
                  {nursery?.input_population}
                </Text>
              </Box>
            </Box>

            <Box alignItems="center" gap={10} width="calc(50% - 10px)">
              <Icon iconName="Flag" htmlColor="#2e7d32" size={40} />
              <Box flexDirection="column" gap={2}>
                <Text fontSize={14}>População final:</Text>
                <Text fontSize={16} fontWeight={500}>
                  {nursery?.population}
                </Text>
              </Box>
            </Box>

            <Box alignItems="center" gap={10} width="calc(50% - 10px)">
              <Icon
                iconName="FunctionsOutlined"
                htmlColor="#2e7d32"
                size={40}
              />
              <Box flexDirection="column" gap={2}>
                <Text fontSize={14}>Sobrevivência média (%):</Text>
                <Text fontSize={16} fontWeight={500}>
                  {nursery?.survival_total_average}
                </Text>
              </Box>
            </Box>

            <Box alignItems="center" gap={10} width="calc(50% - 10px)">
              <Icon
                iconName="WbIridescentOutlined"
                htmlColor="#2e7d32"
                size={40}
              />
              <Box flexDirection="column" gap={2}>
                <Text fontSize={14}>Produção total (kg):</Text>
                <Text fontSize={16} fontWeight={500}>
                  {nursery?.production}
                </Text>
              </Box>
            </Box>

            <Box alignItems="center" gap={10} width="calc(50% - 10px)">
              <Icon
                iconName="TrendingUpOutlined"
                htmlColor="#2e7d32"
                size={40}
              />
              <Box flexDirection="column" gap={2}>
                <Text fontSize={14}>Ganho médio de peso (g):</Text>
                <Text fontSize={16} fontWeight={500}>
                  {nursery?.averageWeightGain}
                </Text>
              </Box>
            </Box>

            <Box alignItems="center" gap={10} width="calc(50% - 10px)">
              <Icon
                iconName="DateRangeOutlined"
                htmlColor="#2e7d32"
                size={40}
              />
              <Box flexDirection="column" gap={2}>
                <Text fontSize={14}>Data de encerramento:</Text>
                <Text fontSize={16} fontWeight={500}>
                  {moment(nursery?.end).format('DD/MM/YYYY')}
                </Text>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ModalNursery;
